var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('strong',[_vm._v("Instructor Registrations for "+_vm._s(_vm.instructor.firstName)+" "+_vm._s(_vm.instructor.lastName))])]},proxy:true}])},[_c('b-card-body',[_c('instructor-registrations-snapshot',{attrs:{"instructorId":_vm.instructor.id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }